// React and related imports
import React from 'react';

// Flowbite Components
import { Button } from 'flowbite-react';

interface PageHeaderProps {
  title: string;
  buttonText?: string;
  buttonOnClick?: () => void;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  buttonText,
  buttonOnClick,
}) => {
  return (
    <div className="mb-6 flex items-center justify-between gap-4">
      <h1 className="text-4xl font-extrabold text-black dark:text-primary-25">
        {title}
      </h1>
      {buttonText && buttonOnClick && (
        <Button size="sm" className="btn btn-dark" onClick={buttonOnClick}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};
